import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader-scroll-preview',
  templateUrl: './loader-scroll-preview.component.html',
  styleUrls: ['./loader-scroll-preview.component.scss'],
  host: { class: 'app-loader-scroll-preview' }
})
export class LoaderScrollPreviewComponent implements OnInit {

  @Input('disabled') disabled:boolean
  @Input('big') big:boolean
  @Input('no-bg') noBg:boolean

  constructor() { }

  ngOnInit(): void {
  }

}
